import React from 'react';
import { MapPin, Building2, FileText, Mail, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Company Info */}
        <div className="footer-section footer-company">
          <h3 className="footer-title">EDP Squared Srls</h3>
          <div className="footer-info">
            <p>
              <MapPin className="footer-icon" size={18} />
              <strong>Sede:</strong> Via I Maggio 25/b, 60131 Ancona (AN)
            </p>
            <p>
              <FileText className="footer-icon" size={18} />
              <strong>P.IVA:</strong> IT02718220425
            </p>
          </div>
        </div>

        {/* Contact Info */}
        <div className="footer-section footer-contact">
          <h3 className="footer-title">Contatti</h3>
          <div className="footer-info">
            <p>
              <Mail className="footer-icon" size={18} />
              <a href="mailto:info@edp.srl">info@edp.srl</a>
            </p>
          </div>
        </div>

        {/* Social Links */}
        <div className="footer-section footer-social">
          <h3 className="footer-title">Seguici</h3>
          <div className="footer-social-links">
            <a 
              href="https://www.linkedin.com/company/10695890/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-social-link"
              aria-label="LinkedIn"
            >
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="currentColor"
              >
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
              <span>LinkedIn</span>
            </a>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p className="footer-disclaimer">I loghi presenti su questo sito sono di proprietà dei rispettivi titolari. Non rivendichiamo alcun diritto sui contenuti di terzi. Per segnalazioni relative ai diritti d'autore, ti invitiamo a contattarci.</p>
        <p>&copy; {new Date().getFullYear()} EDP Squared srls. Tutti i diritti riservati.</p>
      </div>
    </footer>
  );
};

export default Footer;
